import axios from "axios";

// Use the production origin by default; explicit build overrides remain supported.
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

// `withCredentials: true` is required so browser sends the httpOnly auth
// cookies (`adelina_admin_token`, `adelina_emp_token`) with every request.
// The backend still accepts the legacy Authorization header for a smooth
// dual-mode rollout, so existing localStorage sessions keep working until
// they naturally expire.
const api = axios.create({ baseURL: API, withCredentials: true });

// Attach whichever session token is present — for employer-scoped endpoints
// prefer the employer token (backend only accepts employer JWTs there), for
// admin-scoped endpoints prefer the admin token, otherwise fall back.
//
// SECURITY NOTE: JWTs in localStorage are technically vulnerable to XSS token
// theft. We mitigate this by:
//   1. Sanitising all user-supplied HTML with DOMPurify before render
//   2. Using strict Content-Security-Policy headers on the backend
//   3. Setting SHORT JWT expiry (24h for admin, 7d for employer)
//   4. Auth cookies are ALSO set httpOnly so backend can verify via cookie
//      even if localStorage token is stolen. localStorage is a fallback for
//      cross-domain scenarios where cookies aren't sent (e.g. WhatsApp deep
//      links opening in-app browser that strips cookies).
// A full move to cookie-only auth would break some critical download flows
// (bulk PDF, ZIP exports use blob download which needs Bearer header). This
// dual-mode approach is a considered tradeoff.
api.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem("adelina_token");
  const employerToken = localStorage.getItem("adelina_emp_token");
  const url = (config.url || "").toString();
  const isEmployerScope = url.startsWith("/employer/") || url.startsWith("employer/");
  const isAdminScope = url.startsWith("/admin/") || url.startsWith("admin/") || url.startsWith("/v2/admin/");
  let token;
  if (isEmployerScope) {
    token = employerToken || adminToken; // employer JWT first for /employer/*
  } else if (isAdminScope) {
    token = adminToken || employerToken;
  } else {
    token = adminToken || employerToken;
  }
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const resolveMediaUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  return u;
};
